import React from 'react';
import './abouthero.scss';
import {ReactComponent as ELEMENT_01} from "../../../../assets/business-education-assets/elements/be_element_01.svg";

const AboutHero = () => {

    return (
        <div className={'about-hero'}>
            <ELEMENT_01 className={'about-hero_element_01'}/>
            <div className="about-hero_wrapper max">
                <h1>About Small Business Association of Jamaica</h1>
            </div>
        </div>
    )
};

export default AboutHero;
